import { regExForUrl } from '../constants/Regularexpression';

export default function validateData(data) {
  const updated = {};

  // validation for college
  if (data.college !== undefined) {
    const enteredCollege = typeof data.college;
    if (data.college.length > 5 && enteredCollege === 'string') {
      updated.collegeIsValid = true;
    } else {
      updated.collegeErrorMessage = 'Please enter a valid college.';
    }
  } else {
    updated.collegeErrorMessage = 'Please enter college details';
  }
    // twitter validation
  if (data.college_twitter !== undefined) {
    if (data.college_twitter.trim()[0] === '@') {
      updated.twitterIsValid = true;
    } else {
      updated.twitterErrorMessage = 'Please enter valid twitter account';
    }
  } else {
    updated.twitterErrorMessage = 'Please enter twitter details';
  }
  // city validations
  if (data.city !== undefined) {
    const enteredCity = typeof data.city;
    if (data.city.length >= 3 && enteredCity === 'string') {
      updated.cityIsValid = true;
    } else {
      updated.cityErrorMessage = 'Entered city is not valid.';
    }
  } else {
    updated.cityErrorMessage = 'Please enter college details';
  }

  if (data.state !== undefined) {
    const enteredState = typeof data.state;
    if (data.state.length >= 2 && enteredState === 'string') {
      updated.stateIsValid = true;
    } else {
      updated.stateErrorMessage = 'Entered state is not valid.';
    }
  } else {
    updated.stateErrorMessage = 'Please enter state.';
  }

  // validation for min gpa
  if (data.min_gpa !== undefined) {
    if (data.min_gpa <= 4 && data.min_gpa !== '' && !isNaN(data.min_gpa)) {
      updated.gpaIsValid = true;
    } else {
      updated.minGpaErrorMessage = 'Please enter a valid min gpa.';
    }
  } else {
    updated.minGpaErrorMessage = 'Please enter gpa.';
  }

  // validation for min act
  if (data.min_act !== undefined) {
    if (data.min_act !== '' && !isNaN(data.min_act)) {
      updated.actIsValid = true;
    } else {
      updated.minActErrorMessage = 'Please enter a valid min act.';
    }
  } else {
    updated.minActErrorMessage = 'Please enter act.';
  }

  // validation for division
  if (data.division !== undefined) {
    const { division } = data;
    if (division === 'D1' || division === 'D2' || division === 'D3' || division === 'JUCO' || division === 'NAIA') {
      updated.divisionIsValid = true;
    } else {
      updated.divisionErrorMessage = 'Select a division from list.';
    }
  } else {
    updated.divisionErrorMessage = 'Please select a division.';
  }

  // team page validation
  if (data.team_page_link !== undefined) {
    const validUrl = regExForUrl.test(data.team_page_link);
    if (validUrl && data.team_page_link !== '') {
      updated.teamPageLinkIsValid = true;
    } else {
      updated.teamPageErrorMessage = 'Entered team page is not valid.';
    }
  } else {
    updated.teamPageErrorMessage = 'Please add a team page url.';
  }
  // questionaire validation
  if (data.question_link !== undefined) {
    const validUrl = regExForUrl.test(data.question_link);
    if (validUrl && data.question_link !== '') {
      updated.questionLinkIsValid = true;
    } else {
      updated.questionLinkErrorMessage = 'Entered questionaire page is not valid.';
    }
  } else {
    updated.questionLinkErrorMessage = 'Please add a questionaire page url.';
  }

  // validation for football conference
  if (data.football_conf !== undefined) {
    if (data.football_conf !== '') {
      updated.footballConferenceIsValid = true;
    } else {
      updated.footballConferenceErrorMessage = 'Please add a football conference.';
    }
  } else {
    updated.footballConferenceErrorMessage = 'Please add a football conference.';
  }

  // validation for football division
  if (data.football_div !== undefined) {
    if (data.football_div !== '') {
      updated.footballDivisionIsValid = true;
    } else {
      updated.footballDivisionErrorMessage = 'Please add a football division';
    }
  } else {
    updated.footballDivisionErrorMessage = 'Please add a football division';
  }

  // team page validation
  if (data.video_url !== undefined) {
    let validUrl = false;
    if (/^(f|ht)tps?:\/\//i.test(data.video_url)) {
      validUrl = true;
    }
    debugger; // eslint-disable-line
    if (validUrl && data.video_url !== '') {
      updated.urlIsValid = true;
    } else {
      updated.urlErrorMessage = 'Enter a valid video link.';
    }
  } else {
    updated.urlErrorMessage = 'Enter a valid video link.';
  }

  if (data.video_title !== undefined) {
    const enteredTitle = typeof data.video_title;
    if (data.video_title.length >= 3 && enteredTitle === 'string') {
      updated.titleIsValid = true;
    } else {
      updated.titleErrorMessage = 'Please enter title.';
    }
  } else {
    updated.titleErrorMessage = 'Please enter title.';
  }

  return updated;
}



// WEBPACK FOOTER //
// ./src/common/utils/validations.js